/*
	Enlaces directos que llegan sin sesión (ESPEC_AUDITORIA_PREGUNTAS, 2026-10-09): el Cliq trae /auditQuestions?caso=12&plantel=4
	y la supervisora lo abre en el teléfono, donde quizá no ha iniciado sesión. Antes de mandarla a /access se guarda a dónde iba y,
	al entrar, se la lleva ahí (en vez de a la portada). Solo rutas internas ("/algo"), nunca a otro sitio; vale 30 minutos.
*/
const LLAVE = "wa_destino_tras_login";
const VIGENCIA_MS = 30 * 60 * 1000;

export const guardarDestino = (): void => {
	try {
		const ruta = window.location.pathname + window.location.search;
		if (!ruta.startsWith("/") || ruta.startsWith("//") || ruta === "/" || ruta.startsWith("/access")) return;
		sessionStorage.setItem(LLAVE, JSON.stringify({ ruta, en: Date.now() }));
	} catch (e) {
		/* sin sessionStorage: se entra a la portada como siempre */
	}
};

/* Lee el destino guardado sin borrarlo (null si no hay, venció o no es una ruta interna). */
export const verDestino = (): string | null => {
	try {
		const raw = sessionStorage.getItem(LLAVE);
		if (!raw) return null;
		const { ruta, en } = JSON.parse(raw);
		if (typeof ruta !== "string" || !ruta.startsWith("/") || ruta.startsWith("//") || ruta.startsWith("/access") || Date.now() - Number(en) > VIGENCIA_MS) return null;
		return ruta;
	} catch (e) {
		return null;
	}
};

export const tomarDestino = (): string | null => {
	const ruta = verDestino();
	try {
		sessionStorage.removeItem(LLAVE);
	} catch (e) {
		/* nada */
	}
	return ruta;
};
